import clsx from "clsx";
import { motion } from "framer-motion";
import { NoteType } from "../types/NoteType";
import Note from "./Note";

interface ListProps {
  notes: NoteType[];
  chefId?: number;
  canReply?: boolean;
}

const List = ({ notes, chefId, canReply = true }: ListProps) => {
  return (
    <div>
      {notes.map((note) => (
        <motion.div
          key={note.uid}
          initial={{ opacity: 0, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 0 }}
          transition={{ duration: 0.3 }}
          className={clsx("border-t py-6")}
        >
          <Note note={note} chefId={chefId} canReply={canReply} />
        </motion.div>
      ))}
    </div>
  );
};

export default List;
